import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Option } from "app/types";
import React, { useEffect, useRef, useState } from "react";
import CautionDangerIcon from "../Icons/CautionDangerIcon";
import DropdownMenuContentComponent from "./DropdownMenuContentComponent";
import DropdownMenuTriggerComponent from "./DropdownMenuTriggerComponent";
import { SelectProps } from "./types";

export const Select: React.FC<SelectProps<Option[]>> = ({
  options,
  value,
  error,
  label,
  id,
  containerClassName,
  inputClassName,
  labelClassName,
  activeColor,
  icon,
  placeholder,
  onChange,
  innerContainerClassName,
  menuContentClassName,
  menuListItemClassName,
  menuListItemLabelClassName,
  allowSearch,
  searchPlaceholder,
  trigger,
  unPaddedRole = false,
  align = "start",
  showEndIcon = false,
  hasMore,
  loading,
  onLoadMore,
  isPagination,
  disabled = false,
  iconClassName,
  iconSize,
  showRightIcon = false,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setDropdownWidth(containerRef.current.offsetWidth);
    }
  }, []);

  return (
    <div ref={containerRef} className={`relative ${containerClassName}`}>
      <DropdownMenu.Root open={open} onOpenChange={setOpen}>
        <div className={`flex flex-col gap-[6px] ${innerContainerClassName}`}>
          {label && (
            <label
              htmlFor={id}
              className={`text-xs leading-[18px] text-[#79808A] ${labelClassName}`}
            >
              {label}
            </label>
          )}
          <DropdownMenuTriggerComponent
            options={options}
            open={open}
            activeColor={activeColor}
            error={error}
            icon={icon}
            inputClassName={inputClassName}
            placeholder={placeholder}
            trigger={trigger}
            value={value}
            disabled={disabled}
            iconClassName={iconClassName}
            iconSize={iconSize}
          />
          <DropdownMenuContentComponent
            options={options}
            allowSearch={allowSearch}
            menuContentClassName={menuContentClassName}
            menuListItemClassName={menuListItemClassName}
            menuListItemLabelClassName={menuListItemLabelClassName}
            onChange={onChange}
            searchPlaceholder={searchPlaceholder}
            unPaddedRole={unPaddedRole}
            setOpen={setOpen}
            align={align}
            dropdownWidth={dropdownWidth}
            showEndIcon={showEndIcon}
            value={value}
            hasMore={hasMore}
            loading={loading}
            onLoadMore={onLoadMore}
            isPagination={isPagination}
            showRightIcon={showRightIcon}
          />
        </div>
        {error && (
          <p className="text-[11px] leading-[18px] text-danger absolute bottom-[-18px] flex items-center gap-[4px]">
            <CautionDangerIcon />
            <span className="mt-[2px]">{error}</span>
          </p>
        )}
      </DropdownMenu.Root>
    </div>
  );
};
